import { Component } from '@angular/core';

import { SimpleTableComponent } from '../simple-table/simple-table.component';

@Component({
	selector: 'dl-simple-first-column-table',
	templateUrl: './simple-first-column-table.component.html',
	styleUrls: ['./simple-first-column-table.component.scss']
})

export class SimpleFirstColumnTableComponent extends SimpleTableComponent {
}
